<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <BreadCrumd
          :title="'Gestion des employés'"
          :description="'Nouvel employé'"
        />
      </div>
    </div>
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>

        <div class="row">
          <div class="col-md-12">
            <b-card class="text-black" header-class="bg-silver">
              <template #header>
                <div>
                  <h5 class="font-size-16 mb-0">
                    <i class="fa fa-id-card mr-0"></i> Etat civil
                  </h5>
                </div>
              </template>
              <div class="row">
                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="nom"
                      >Nom <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{ 'is-invalid': form.errors.has('nom') }"
                      id="nom"
                      v-model="form.nom"
                      type="text"
                      placeholder="Nom"
                      maxlength="50"
                      required
                    />
                    <has-error :form="form" field="nom"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="prenom"
                      >Prénom <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{ 'is-invalid': form.errors.has('prenom') }"
                      id="prenom"
                      v-model="form.prenom"
                      type="text"
                      placeholder="Prénom"
                      maxlength="50"
                      required
                    />
                    <has-error :form="form" field="prenom"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="matricule">Matricule </label>
                    <input
                      class="form-control"
                      :class="{ 'is-invalid': form.errors.has('matricule') }"
                      id="matricule"
                      v-model="form.matricule"
                      type="text"
                      placeholder="Matricule"
                      maxlength="20"
                    />
                    <has-error :form="form" field="matricule"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="civilite"
                      >Civilité <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      label="nom"
                      id="civilite"
                      :options="civilites"
                      :reduce="(civilite) => civilite.uuid"
                      v-model="form.civilite"
                      placeholder="Civilité"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="civilite"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('civilite'),
                      }"
                    />
                    <has-error :form="form" field="civilite"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3 mt-n3">
                  <div class="form-group">
                    <label for="date_naissance">Date de naissance </label>
                    <date-picker
                      v-model="form.date_naissance"
                      name="date_naissance"
                      placeholder="Date de naissance"
                      lang="fr"
                      format="DD/MM/YYYY"
                      value-type="DD/MM/YYYY"
                    ></date-picker>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('date_naissance'),
                      }"
                      type="hidden"
                    />
                    <has-error :form="form" field="date_naissance"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3 mt-n3">
                  <div class="form-group">
                    <label for="lieu_naissance">Lieu de naissance </label>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('lieu_naissance'),
                      }"
                      id="lieu_naissance"
                      v-model="form.lieu_naissance"
                      type="text"
                      placeholder="Lieu de naissance"
                      maxlength="50"
                    />
                    <has-error :form="form" field="lieu_naissance"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3 mt-n3">
                  <div class="form-group">
                    <label for="pays_naissance">Pays de naissance </label>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('pays_naissance'),
                      }"
                      id="pays_naissance"
                      v-model="form.pays_naissance"
                      type="text"
                      placeholder="Pays de naissance"
                      maxlength="50"
                    />
                    <has-error :form="form" field="pays_naissance"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3 mt-n3">
                  <div class="form-group">
                    <label for="nationalite">Nationalité </label>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('nationalite'),
                      }"
                      id="nationalite"
                      v-model="form.nationalite"
                      type="text"
                      placeholder="Nationalité"
                      maxlength="50"
                    />
                    <has-error :form="form" field="nationalite"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3 mt-n3">
                  <div class="form-group">
                    <label for="telephone">Téléphone </label>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('telephone'),
                      }"
                      id="telephone"
                      v-model="form.telephone"
                      type="text"
                      placeholder="Téléphone"
                      maxlength="50"
                    />
                    <has-error :form="form" field="telephone"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3 mt-n3">
                  <div class="form-group">
                    <label for="email_principal">Email principal </label>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('email_principal'),
                      }"
                      id="email_principal"
                      v-model="form.email_principal"
                      type="email"
                      placeholder="Email principal"
                      maxlength="100"
                    />
                    <has-error :form="form" field="email_principal"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3 mt-n3">
                  <div class="form-group">
                    <label for="num_securite_sociale"
                      >N° de sécurité sociale
                    </label>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('num_securite_sociale'),
                      }"
                      id="num_securite_sociale"
                      v-model="form.num_securite_sociale"
                      type="text"
                      placeholder="N° de sécurité sociale"
                      maxlength="50"
                    />
                    <has-error
                      :form="form"
                      field="num_securite_sociale"
                    ></has-error>
                  </div>
                </div>
                <div class="col-md-6 col-lg-3 mt-n3">
                  <div class="form-group">
                    <label for="code_postal">Code postal </label>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('code_postal'),
                      }"
                      id="code_postal"
                      v-model="form.code_postal"
                      type="text"
                      placeholder="Code postal"
                      maxlength="5"
                    />
                    <has-error :form="form" field="code_postal"></has-error>
                  </div>
                </div>
                <div class="col-md-6 col-lg-3 mt-n3">
                  <div class="form-group">
                    <label for="ville">Ville </label>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('ville'),
                      }"
                      id="ville"
                      v-model="form.ville"
                      type="text"
                      placeholder="Ville"
                      maxlength="50"
                    />
                    <has-error :form="form" field="ville"></has-error>
                  </div>
                </div>
                <div class="col-md-6 col-lg-6 mt-n3">
                  <div class="form-group">
                    <div class="form-group">
                      <label for="adresse">Adresse </label>
                      <textarea
                        id="adresse"
                        v-model="form.adresse"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('adresse'),
                        }"
                        rows="5"
                        maxlength="100"
                      ></textarea>
                      <has-error :form="form" field="adresse"></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>
        <div class="row mt-n4">
          <div class="col-md-12 col-lg-6">
            <b-card class="text-black" header-class="bg-silver">
              <template #header>
                <div>
                  <h5 class="font-size-16 mb-0">
                    <i class="fa fa-cube mr-0"></i> Situation familiale
                  </h5>
                </div>
              </template>
              <div class="row">
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label for="situation_familiale"
                      >Situation familiale
                    </label>
                    <v-custom-select
                      label="nom"
                      id="situation_familiale"
                      :options="situationFamiliales"
                      v-model="form.situation_familiale"
                      :reduce="(situationFamiliale) => situationFamiliale.uuid"
                      placeholder="Situation familiale"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="situation_familiale"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('situation_familiale'),
                      }"
                    />
                    <has-error
                      :form="form"
                      field="situation_familiale"
                    ></has-error>
                  </div>
                </div>
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label for="lien_parente_employeur"
                      >Lien de parenté avec l'employeur
                    </label>
                    <v-custom-select
                      label="nom"
                      id="lien_parente_employeur"
                      :options="lienParentes"
                      v-model="form.lien_parente_employeur"
                      :reduce="(lienParente) => lienParente.uuid"
                      placeholder="Lien de parenté avec l'employeur"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="lien_parente_employeur"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('lien_parente_employeur'),
                      }"
                    />
                    <has-error
                      :form="form"
                      field="lien_parente_employeur"
                    ></has-error>
                  </div>
                </div>
                <div class="col-md-6 col-lg-6 mt-n3">
                  <div class="form-group">
                    <label for="nombre_adulte">Nombre d'adultes </label>
                    <div class="input-group">
                      <div
                        class="input-group-prepend bg-transparent"
                        @click="
                          form.nombre_adulte =
                            form.nombre_adulte - 1 > 0
                              ? form.nombre_adulte - 1
                              : 1
                        "
                      >
                        <span
                          class="input-group-text bg-transprent border-right-0"
                          role="button"
                        >
                          <i class="fas fa-minus text-danger"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control text-center"
                        :class="{
                          'is-invalid': form.errors.has('nombre_adulte'),
                        }"
                        id="nombre_adulte"
                        v-model.number="form.nombre_adulte"
                        placeholder="Nombre de poste"
                        required
                      />
                      <div
                        class="input-group-append bg-transparent"
                        @click="form.nombre_adulte++"
                      >
                        <span
                          class="input-group-text bg-transprent border-left-0"
                          role="button"
                        >
                          <i class="fas fa-plus text-success"></i>
                        </span>
                      </div>
                      <has-error :form="form" field="nombre_adulte"></has-error>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-lg-6 mt-n3">
                  <div class="form-group">
                    <label for="nombre_enfant">Nombre d'enfants </label>
                    <div class="input-group">
                      <div
                        class="input-group-prepend bg-transparent"
                        @click="
                          form.nombre_enfant =
                            form.nombre_enfant - 1 > 0
                              ? form.nombre_enfant - 1
                              : 1
                        "
                      >
                        <span
                          class="input-group-text bg-transprent border-right-0"
                          role="button"
                        >
                          <i class="fas fa-minus text-danger"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control text-center"
                        :class="{
                          'is-invalid': form.errors.has('nombre_enfant'),
                        }"
                        id="nombre_enfant"
                        v-model.number="form.nombre_enfant"
                        placeholder="Nombre de poste"
                        required
                      />
                      <div
                        class="input-group-append bg-transparent"
                        @click="form.nombre_enfant++"
                      >
                        <span
                          class="input-group-text bg-transprent border-left-0"
                          role="button"
                        >
                          <i class="fas fa-plus text-success"></i>
                        </span>
                      </div>
                      <has-error :form="form" field="nombre_enfant"></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
          <div class="col-md-12 col-lg-6">
            <b-card class="text-black" header-class="bg-silver">
              <template #header>
                <div>
                  <h5 class="font-size-16 mb-0">
                    <i class="fa fa-cube mr-0"></i> En cas d'urgence
                  </h5>
                </div>
              </template>
              <div class="row">
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label for="urgence_contact_nom">Nom </label>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('urgence_contact_nom'),
                      }"
                      id="urgence_contact_nom"
                      v-model="form.urgence_contact_nom"
                      type="text"
                      placeholder="Nom"
                      maxlength="100"
                    />
                    <has-error
                      :form="form"
                      field="urgence_contact_nom"
                    ></has-error>
                  </div>
                </div>
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label for="urgence_contact_telephone">Téléphone </label>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has(
                          'urgence_contact_telephone'
                        ),
                      }"
                      id="urgence_contact_telephone"
                      v-model="form.urgence_contact_telephone"
                      type="text"
                      placeholder="Téléphone"
                      maxlength="50"
                    />
                    <has-error
                      :form="form"
                      field="urgence_contact_telephone"
                    ></has-error>
                  </div>
                </div>
                <div class="col-md-6 col-lg-6 mt-n3">
                  <div class="form-group">
                    <label for="urgence_contact_lien_parente"
                      >Lien de parenté
                    </label>
                    <v-custom-select
                      label="nom"
                      id="urgence_contact_lien_parente"
                      :options="lienParentes"
                      v-model="form.urgence_contact_lien_parente"
                      :reduce="(lienParente) => lienParente.uuid"
                      placeholder="Lien de parenté"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="urgence_contact_lien_parente"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has(
                          'urgence_contact_lien_parente'
                        ),
                      }"
                    />
                    <has-error
                      :form="form"
                      field="urgence_contact_lien_parente"
                    ></has-error>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>
        <div class="row mt-n4">
          <div class="col-md-12 col-lg-6">
            <b-card class="text-black" header-class="bg-silver">
              <template #header>
                <div>
                  <h5 class="font-size-16 mb-0">
                    <i class="fa fa-cube mr-0"></i> Restriction médicale
                  </h5>
                </div>
              </template>
              <div class="row">
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label for="restriction_medicale"
                      >Restriction médicale
                    </label>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('restriction_medicale'),
                      }"
                      id="restriction_medicale"
                      v-model="form.restriction_medicale"
                      type="text"
                      placeholder="Restriction médicale"
                      maxlength="50"
                    />
                    <has-error
                      :form="form"
                      field="restriction_medicale"
                    ></has-error>
                  </div>
                </div>
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <div class="form-group">
                      <label for="maladie_professionnelle"
                        >Maladies professionelles
                      </label>
                      <textarea
                        id="maladie_professionnelle"
                        v-model="form.maladie_professionnelle"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has(
                            'maladie_professionnelle'
                          ),
                        }"
                        rows="5"
                        maxlength="100"
                      ></textarea>
                      <has-error
                        :form="form"
                        field="maladie_professionnelle"
                      ></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>
        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-secondary mr-4"
              @click.prevent="
                $router.push({ name: 'rh_employe' }).catch(() => {})
              "
            >
              Liste des employés
            </button>

            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Créer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL_E from '@/http/rh/employe';
import URL_C from '@/http/rh/candidature/candidature';
import Form from 'vform';
import DatePicker from 'vue2-datepicker';

export default {
  data() {
    return {
      form: new Form({
        nom: '',
        prenom: '',
        matricule: '',
        telephone: '',
        email_principal: '',
        email: '',
        password: '',
        civilite: '',

        date_naissance: '',
        lieu_naissance: '',
        pays_naissance: '',
        ville: '',
        code_postal: '',
        nationalite: '',
        adresse: '',
        num_securite_sociale: '',
        situation_familiale: '',
        nombre_adulte: 0,
        nombre_enfant: 0,
        lien_parente_employeur: '',
        urgence_contact_nom: '',
        urgence_contact_telephone: '',
        urgence_contact_lien_parente: '',
        restriction_medicale: '',
        maladie_professionnelle: '',
      }),
      showPassword: false,
      showPasswordConfirm: false,

      civilites: [],
      situationFamiliales: [],
      lienParentes: [],
      id: null,

      title: 'Gestion des employés - Création',
    };
  },
  components: {
    DatePicker,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    init() {
      this.id = this.$route.params.id;
      this.civilites = [];
      this.situationFamiliales = [];
      this.lienParentes = [];

      if (this.$route.params.filter === 'cloner') {
        window.axios
          .all([
            window.axios.get(URL_E.GET_REQUIREMENTS),
            window.axios.get(URL_E.EMPLOYE + '/' + this.id, {
              params: { edit: true },
            }),
          ])
          .then(
            window.axios.spread((resp1, resp2) => {
              this.civilites = resp1.data.civilites;
              this.situationFamiliales = resp1.data.situation_familiales;
              this.lienParentes = resp1.data.lien_parentes;
              Object.assign(this.form, resp2.data.employe);
              delete this.form.id;
            })
          )
          .catch();
      } else if (this.$route.params.filter === 'candidat') {
        window.axios
          .all([
            window.axios.get(URL_E.GET_REQUIREMENTS),
            window.axios.get(URL_C.CANDIDATURE + '/' + this.id, {
              params: { edit: true },
            }),
          ])
          .then(
            window.axios.spread((resp1, resp2) => {
              this.civilites = resp1.data.civilites;
              this.situationFamiliales = resp1.data.situation_familiales;
              this.lienParentes = resp1.data.lien_parentes;

              Object.assign(this.form, resp2.data.candidature);
              this.form.email_principal = this.form.email;
              delete this.form.id;
              delete this.form.document;
              delete this.form.statut;
              delete this.form.email;
            })
          )
          .catch();
      } else {
        window.axios
          .get(URL_E.GET_REQUIREMENTS)
          .then((resp) => {
            this.civilites = resp.data.civilites;
            this.situationFamiliales = resp.data.situation_familiales;
            this.lienParentes = resp.data.lien_parentes;
          })
          .catch();
      }
    },

    submit() {
      if (this.id && this.$route.params.filter === 'candidat')
        this.form.candidat = this.id;

      this.itemListErrorMessage = null;
      this.form
        .post(URL_E.EMPLOYE)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.$router.push({
            name: 'rh_employe-show',
            params: { id: resp.data.employe.id },
          });
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
